import { render, staticRenderFns } from "./multi-select.vue?vue&type=template&id=af8ab88e&scoped=true"
import script from "./multi-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./multi-select.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./multi-select.vue?vue&type=style&index=0&id=af8ab88e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8ab88e",
  null
  
)

export default component.exports